module.exports = __webpack_public_path__ + "img/38.ef40767a.png";